import type { PathSegment } from 'modules/payroll_bundle/lib/types'

export function comparePaths(locationPath: string, givenPath: string): boolean {
  const locationSegments = getPathSegments(locationPath)
  const givenSegments = getPathSegments(givenPath)

  if (locationSegments.length !== givenSegments.length) {
    return false
  }

  for (let i = 0; i < locationSegments.length; i++) {
    const locationSegment = locationSegments[i]
    const givenSegment = givenSegments[i]

    if (!areSegmentsEqual(locationSegment, givenSegment)) {
      return false
    }
  }

  return true
}

function getPathSegments(path: string): (PathSegment | undefined)[] {
  return path
    .split('/')
    .filter(Boolean)
    .map((segment) => {
      // Parse numeric segments as numbers
      const numericSegment = parseInt(segment, 10)
      return isNaN(numericSegment) ? segment : numericSegment
    })
}

function areSegmentsEqual(
  locationSegment: PathSegment | undefined,
  givenSegment: PathSegment | undefined
): boolean {
  // Check if both segments are undefined
  if (typeof locationSegment === 'undefined' && typeof givenSegment === 'undefined') {
    return true
  }

  // Strict equality check for non-ID segments
  if (typeof locationSegment !== 'number' && typeof givenSegment !== 'number') {
    return locationSegment === givenSegment
  }

  // ID segments are considered equal
  return true
}
